import { BaseInfoType, StoreInfoType } from '@kinderlabs-pos/shared-data-type';

import { posAxiosClient } from '@kinderlabs-pos/apis/axios';

export const getStoreInfoListAsync = (rootUrl: string) => async () =>
	(await posAxiosClient.get<(StoreInfoType & BaseInfoType)[]>(`${rootUrl}/store/list`)).data;
